<div class="flex-column search-form">
  <h1>Buscar {{searchTitle}}</h1>
  <hr>
  
  <!-- Opciones iniciales -->
  <div *ngIf="searchResults.length > 0 && !searchString" class="initial-options mb-3">
    <h5 class="text-primary mb-3">
      <i class="fas fa-list me-2"></i>
      Opciones Disponibles ({{totalItems}} en total)
    </h5>
    <div class="alert alert-info">
      <i class="fas fa-info-circle me-2"></i>
      <strong>Seleccione una opción de la lista o escriba para buscar específicamente</strong>
    </div>
  </div>
  
  <label *ngIf="searchItem === 1">Busqueda por Dirección</label>
  <label *ngIf="searchItem === 2 || searchItem === 3 || searchItem === 4">Busqueda por Nombre</label>
  <input #searchBox class="form-control" type="text" [(ngModel)]="searchString" style="width: 15vw;" placeholder="Escriba para buscar">
  
  <div *ngIf="{stream: results$ | async} as observable">
    <span style="margin-top: 10px;" *ngIf="searching && searchString != ''">Buscando...</span>
    <span *ngIf="!searching && observable.stream?.result?.length > 0 && searchString != ''">Resultado de la Búsqueda</span>
    <span *ngIf="!searching && (observable.stream?.result?.length == 0 || observable.stream?.result == null) && searchString != ''">
      No se encontraron resultados</span>
    <table class="table" *ngIf="!searching && observable.stream?.result?.length > 0 && searchString">
      <thead>
        <tr *ngIf="searchItem === 1">
          <th *ngFor="let header of buildingHeader">{{header | translate}}</th>
          <th>Acción</th>
        </tr>
        <tr *ngIf="searchItem != 1">
          <th *ngFor="let header of personHeader">{{header | translate}}</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody *ngIf="searchItem === 1" >
        <tr *ngFor="let result of observable.stream?.result" class="hoverlightbluebg">
          <td>
            <strong>{{result.address.streetAddress}}</strong><br>
            <small class="text-muted">{{result.address.city}}, {{result.address.state}}</small>
          </td>
          <td>
            <span class="badge bg-secondary">{{result.identification}}</span>
          </td>
          <td>
            <button class="btn btn-sm btn-primary" (click)="selectElement(result)">
              <i class="fas fa-check me-1"></i>Seleccionar
            </button>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="searchItem === 2 || searchItem === 3" >
        <tr *ngFor="let result of observable.stream?.result" class="hoverlightbluebg">
          <td>{{result.user.person.fullName}}</td>
          <td>{{result.user.email}}</td>
          <td>{{result.user.person.documentId}}</td>
          <td>
            <button class="btn btn-sm btn-primary" (click)="selectElement(result)">
              <i class="fas fa-check me-1"></i>Seleccionar
            </button>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="searchItem === 4" >
        <tr *ngFor="let result of observable.stream?.result" class="hoverlightbluebg">
          <td>{{result.person.fullName}}</td>
          <td>{{result.email}}</td>
          <td>{{result.person.documentId}}</td>
          <td>
            <button class="btn btn-sm btn-primary" (click)="selectElement(result)">
              <i class="fas fa-check me-1"></i>Seleccionar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
     <div class="paginator-component" *ngIf="observable.stream?.result?.length > 0 && searchString">
       <ngb-pagination (pageChange)="searchPageChanged($event)" [(page)]="page" [pageSize]="5" 
         [collectionSize]="observable.stream?.pagination.totalItems" [boundaryLinks]="true" [maxSize]="5">
         <ng-template ngbPaginationPrevious>Ant</ng-template>
         <ng-template ngbPaginationNext>Sig</ng-template>
       </ngb-pagination>
     </div>
  </div>
  
  <!-- Tabla de opciones iniciales -->
  <div *ngIf="searchResults.length > 0 && !searchString && !searching">
    <table class="table table-hover">
      <thead>
        <tr *ngIf="searchItem === 1">
          <th *ngFor="let header of buildingHeader">{{header | translate}}</th>
          <th>Acción</th>
        </tr>
        <tr *ngIf="searchItem != 1">
          <th *ngFor="let header of personHeader">{{header | translate}}</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody *ngIf="searchItem === 1">
        <tr *ngFor="let result of searchResults" class="hoverlightbluebg">
          <td>
            <strong>{{result.address.streetAddress}}</strong><br>
            <small class="text-muted">{{result.address.city}}, {{result.address.state}}</small>
          </td>
          <td>
            <span class="badge bg-secondary">{{result.identification}}</span>
          </td>
          <td>
            <button class="btn btn-sm btn-primary" (click)="selectElement(result)">
              <i class="fas fa-check me-1"></i>Seleccionar
            </button>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="searchItem === 2 || searchItem === 3">
        <tr *ngFor="let result of searchResults" class="hoverlightbluebg">
          <td>{{result.user.person.fullName}}</td>
          <td>{{result.user.email}}</td>
          <td>{{result.user.person.documentId}}</td>
          <td>
            <button class="btn btn-sm btn-primary" (click)="selectElement(result)">
              <i class="fas fa-check me-1"></i>Seleccionar
            </button>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="searchItem === 4">
        <tr *ngFor="let result of searchResults" class="hoverlightbluebg">
          <td>{{result.person.fullName}}</td>
          <td>{{result.email}}</td>
          <td>{{result.person.documentId}}</td>
          <td>
            <button class="btn btn-sm btn-primary" (click)="selectElement(result)">
              <i class="fas fa-check me-1"></i>Seleccionar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- Paginación para opciones iniciales -->
    <div class="paginator-component" *ngIf="searchResults.length > 0 && !searchString && !searching">
      <ngb-pagination (pageChange)="loadInitialOptionsPage($event)" [(page)]="page" [pageSize]="5" 
        [collectionSize]="totalItems" [boundaryLinks]="true" [maxSize]="5">
        <ng-template ngbPaginationPrevious>Ant</ng-template>
        <ng-template ngbPaginationNext>Sig</ng-template>
      </ngb-pagination>
    </div>
  </div>
</div>
